<template>
  <div class="left_nav">
    <el-menu
      :default-active="defaultActiveMenuIndex"
      :collapse="isCollapse"
      class="el-menu-vertical-demo"
    >
      <el-menu-item index="1" @click="toNewRouter('call-police')">
        <i class="el-icon-damai-zhuangtairizhi"></i>
        <span slot="title">报警记录</span>
      </el-menu-item>

      <div
        style="
          line-height: 50px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          padding-left: 25px;
        "
      >
        <i
          class="el-icon-s-fold"
          style="font-size: 24px; color: #00a0e6; cursor: pointer"
          @click="isCollapse = true"
          v-if="!isCollapse"
        ></i>
        <i
          class="el-icon-s-unfold"
          style="font-size: 24px; color: #00a0e6; cursor: pointer"
          @click="isCollapse = false"
          v-if="isCollapse"
        ></i>
      </div>
    </el-menu>
  </div>
</template>

<script>
import navMixin from "../../utils/nav";
import { bus } from "../../utils/bus";

const indexOfRouterNameEntities = Object.entries({
  1: "call-police",
});

export default {
  name: "investment-leasing-nav",
  mixins: [navMixin],
  computed: {
    defaultActiveMenuIndex() {
      const { name: routeName } = this.$route;
      const entity = indexOfRouterNameEntities.find(([, routeNames]) => {
        if (routeNames instanceof Array) {
          return routeNames.indexOf(routeName) >= 0;
        } else {
          return routeNames === routeName;
        }
      });
      return entity && entity[0];
    },
  },
  data() {
    return {
      isCollapse: false,
      permissionCodes: "",
      indexOfRouterNameEntities,
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
  },
  methods: {
    toNewRouter(name) {
      this.$router.push({
        name: name,
      });
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../components/CommonStyle/commonNavStyle";
</style>



// WEBPACK FOOTER //
// src/view/CallPolice/CallPoliceNav.vue